import type { Client, RequestContext } from "../client";
import type { CreatePolicyCommand, CompliancePolicyVersionResource, GitRef, ModifyPolicyCommand, PolicyResource, PolicySummary, PublishCompliancePolicyCommand, PolicyBffResource } from "../resources";
export class PolicyRepository {
    protected readonly client: Client;
    protected readonly context: RequestContext;
    protected apiBaseRoute: string = "~/api/platformhub";
    constructor(client: Client, requestContext: RequestContext) {
        this.client = client;
        this.context = requestContext;
    }
    get(slug: string, gitRef: GitRef): Promise<GetCompliancePolicyBySlugBffResponse> {
        return this.client.get<GetCompliancePolicyBySlugBffResponse>(this.context, "~/bff/{gitRef}/policies/{slug}", { slug, gitRef });
    }
    getSummaries(policiesPageFilter: GetPolicySummariesBffRequest): Promise<GetPolicySummariesBffResponse> {
        return this.client.get<GetPolicySummariesBffResponse>(this.context, "~/bff/{gitRef}/policies/summaries{?skip,take,partialName}", policiesPageFilter);
    }
    modify(policy: ModifyPolicyCommand) {
        return this.client.put<PolicyResource>(this.context, `${this.apiBaseRoute}/{gitRef}/policies/{slug}`, policy, { gitRef: policy.GitRef, slug: policy.Slug });
    }
    create(policy: CreatePolicyCommand) {
        return this.client.post<PolicyResource>(this.context, `${this.apiBaseRoute}/{gitRef}/policies/`, policy, { gitRef: policy.GitRef });
    }
    publish(policy: PublishCompliancePolicyCommand): Promise<CompliancePolicyVersionResource> {
        return this.client.post<CompliancePolicyVersionResource>(this.context, "~/api/platformhub/{gitRef}/policies/{slug}/publish", policy, { gitRef: policy.GitRef, slug: policy.Slug });
    }
    getVersions(slug: string): Promise<CompliancePolicyVersionResource[]> {
        return this.client.get<CompliancePolicyVersionResource[]>(this.context, "~/api/platformhub/policies/{slug}/versions", { slug });
    }
    updateActivationStatus(command: UpdatePolicyActivationStatusCommand): Promise<CompliancePolicyVersionResource> {
        return this.client.post<CompliancePolicyVersionResource>(this.context, "~/api/platformhub/policies/{slug}/versions/{version}/modify-status", { isActive: command.IsActive }, { slug: command.Slug, version: command.Version });
    }
}
export type GetPolicySummariesBffRequest = {
    skip: number;
    take: number;
    partialName?: string;
    gitRef: string;
};
export interface GetCompliancePolicyBySlugBffResponse {
    Policy: PolicyBffResource;
}
export interface GetPolicySummariesBffResponse {
    Policies: PolicySummary[];
    FilteredItemsCount: number;
    ItemsPerPage: number;
    TotalItemsCount: number;
}
export interface UpdatePolicyActivationStatusCommand {
    Slug: string;
    Version: string;
    IsActive: boolean;
}
